import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

function TestMockGate() {
  const { outcomeEntrypointSelector } = useSearchParamOrDefaultProps();

  if (!outcomeEntrypointSelector) {
    return null;
  }

  const isId = outcomeEntrypointSelector.startsWith('#');
  const isClassName = outcomeEntrypointSelector.startsWith('.');

  const selectorWithoutPrefix = outcomeEntrypointSelector.replace(/\.|#/i, '');

  const selectorAttributes = {};
  if (isId) {
    selectorAttributes.id = selectorWithoutPrefix;
  }

  if (isClassName) {
    selectorAttributes.className = selectorWithoutPrefix;
  }

  return <div {...selectorAttributes} />;
}

export default TestMockGate;
